// Calendar is shared configuration; future destination transit values are additive.
if (!customElements.get('ib-delivery-estimate')) {
  customElements.define('ib-delivery-estimate',class extends HTMLElement {
    connectedCallback(){
      const calendar=JSON.parse(this.querySelector('[data-ib-calendar]').textContent);
      const weekdays=calendar.weekdays||[1,2,3,4,5];
      const excluded=new Set(calendar.excludedDates||[]);
      const addDays=(start,count)=>{
        const date=new Date(start+'T12:00:00Z');let remaining=count;
        while(remaining>0){date.setUTCDate(date.getUTCDate()+1);if(weekdays.includes(date.getUTCDay())&&!excluded.has(date.toISOString().slice(0,10)))remaining--;}
        return date;
      };
      const hasTransit=this.dataset.transitMin!==''&&this.dataset.transitMax!=='';
      const minimum=Number(this.dataset.min)+(hasTransit?Number(this.dataset.transitMin):0);
      const maximum=Number(this.dataset.max)+(hasTransit?Number(this.dataset.transitMax):0);
      const format=new Intl.DateTimeFormat(document.documentElement.lang === 'en' ? 'en-GB' : 'ro-RO',{day:'numeric',month:'long',timeZone:'Europe/Bucharest'});
      const range=format.format(addDays(this.dataset.today,minimum))+' – '+format.format(addDays(this.dataset.today,maximum));
      this.querySelector('[data-ib-estimated-date]').textContent=(hasTransit?this.dataset.deliveryLabel:this.dataset.dispatchLabel)+' '+range+'.';
    }
  });
}
